export const API_ROOT_COMMS = process.env.REACT_APP_API_HOST_COMMS!;
export const API_HOST_EXPERTS_APPLY = process.env.REACT_APP_API_HOST_EXPERTS_APPLY!;